import layout from '@/layout'

export default {
  path: '/user',
  component: layout,
  redirect: '/user/userStock',
  name: 'userStock',
  meta: {
    title: 'user',
    icon: 'admin'
  },
  children: [
    {
      path: '/user/userStock',
      name: 'userStock',
      component: () => import('@/views/user/user-stock/index.vue'),
      meta: {
        title: 'userStock',
        icon: 'admin'
      }
    }
  ]
}
